/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_kyc_gate_modal_title = /** @type {(inputs: {}) => string} */ () => {
	return `Verificación de identidad requerida`
};

const en_kyc_gate_modal_title = /** @type {(inputs: {}) => string} */ () => {
	return `Identity verification required`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kyc_gate_modal_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kyc_gate_modal_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kyc_gate_modal_title", locale)
	if (locale === "es") return es_kyc_gate_modal_title(inputs)
	return en_kyc_gate_modal_title(inputs)
};
export { kyc_gate_modal_title as "kyc_gate.modal_title" }